import { useState, useEffect } from "react";

export const useCachedElementDimensions = (selector: string) => {
  const [dimensions, setDimensions] = useState({
    offsetTop: 0,
    offsetBottom: 0,
    height: 0,
  });

  useEffect(() => {
    const calculate = () => {
      const el = document.getElementById(selector);
      if (!el) return;

      const rect = el.getBoundingClientRect();

      const offsetTop = el.offsetTop;
      const height = rect.height;
      const offsetBottom = offsetTop + height;

      setDimensions({ offsetTop, height, offsetBottom });
    };

    calculate();
    window.addEventListener("resize", calculate);
    return () => window.removeEventListener("resize", calculate);
  }, [selector]);

  return dimensions;
};
